import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

const STANDING_OFFER = gql(`
  query standingOffer($standingOfferId: ID!) {
    standingOffer(standingOfferId: $standingOfferId) {
      ... on StandingOffer {
        __typename
        id
        name
        message
        status
        app {
          __typename
          id
          displayName
          description
          slug
          pictureUrl
        }
        offeringOrganization {
          __typename
          id
          name
        }
        payment {
          __typename
          monthlyPriceUSD
          trialDays
        }
      }
      ... on SubscriptionOfferNotFound {
        __typename
        id
      }
    }
  }
`);

export function useStandingOffer(standingOfferId: string) {
  return useQuery(STANDING_OFFER, { variables: { standingOfferId } });
}
